module.exports = __webpack_public_path__ + "static/media/dish1.4d90d148.jpg";